import React from 'react';
import { AltNavBar } from '../components/NavBar';
import Localization from '../localization';
import { formatDate } from '../utils/utils';
import ReactGA from 'react-ga4';

import conf from '../config/web-site.json';

import '../styles/Shows.scss';

const showKeys: (keyof typeof conf.shows)[] = Object.keys(conf.shows) as (keyof typeof conf.shows)[];
const strings = Localization.getStrings();

type ShowProps = {
  scroller: (arg: string) => void;
  config?: typeof conf;
}

// Repeating 8-tile puzzle pattern:
// 0 → big (2×2), 2 → tall (1×2), 5 → wide (2×1), rest → regular
const PUZZLE: Record<number, string> = { 0: 'big', 2: 'tall', 5: 'wide' };
const getPuzzleClass = (i: number): string => {
  const variant = PUZZLE[i % 8];
  return variant ? `show-card--${variant}` : '';
};

const Shows: React.FC<ShowProps> = (props) => {
  const { scroller } = props;

  return (
    <section id="shows" className="shows-section" data-testid="shows-view">
      <AltNavBar {...{ scroller, source: conf.pages.shows.title }} />
      <h1 className="shows-heading">{strings['b_shows']}</h1>

      <div className="shows-grid-wrap">
        <div className="shows-grid">
        {showKeys.map((key, i) => (
          <div
            key={key}
            className={`show-card ${getPuzzleClass(i)}${i === 0 ? ' show-card--latest' : ''}`}
            data-testid="show-card"
            onClick={() => {
              ReactGA.event({
                category: conf.analytics.parameters.categories.navigation,
                action: `Navigated to ${strings[`${key}_title`]} show`,
                label: conf.analytics.parameters.labels.click,
              });
            }}
          >
            <div className="show-card-image-wrap">
              {i === 0 && (
                <span className="show-card-latest-badge">{strings['b_latest_show']}</span>
              )}
              <img
                src={require(`../assets/img/shows/${conf.shows[key].image}`)}
                alt={strings[`${key}_title`]}
                className="show-card-img"
              />
              <div className="show-card-overlay">
                <strong className="show-card-title">{strings[`${key}_title`]}</strong>
                <span className="show-card-desc">{strings[`${key}_description`]}</span>
                <span className="show-card-date">{formatDate(conf.shows[key].date)}</span>
              </div>
            </div>
          </div>
        ))}
        </div>
      </div>
    </section>
  );
};

export default Shows;